import { Upload, message } from "antd";

export const handleBeforeUploadFile = ({
  file,
  setFile,
  selectedHeader,
  cardIndex,
  componentIndex,
  setIsPanelOpened,
  setIsConvertCompressDialogOpen,
  selectedNode,
  selectedNodeConvertCompress,
  setSelectedNodeConvertCompress,
  carouselCardIndex,
  setCarouselCardIndex,
  carouselComponentIndex,
  setCarouselComponentIndex,
}) => {
  const isImage = selectedHeader.toLowerCase() === "image";
  const isVideo = selectedHeader.toLowerCase() === "video";

  const isValidSize = isImage
    ? file.size <= 1024 * 1024 * 5
    : file.size <= 1024 * 1024 * 16;

  const openConvertCompressDialog = () => {
    setFile(file);

    if (
      setSelectedNodeConvertCompress &&
      selectedNode &&
      !selectedNodeConvertCompress
    ) {
      setSelectedNodeConvertCompress(selectedNode);
    }
    if (setCarouselCardIndex && cardIndex !== undefined && !carouselCardIndex) {
      setCarouselCardIndex(cardIndex);
    }
    if (
      setCarouselComponentIndex &&
      componentIndex !== undefined &&
      !carouselComponentIndex
    ) {
      setCarouselComponentIndex(componentIndex);
    }

    setIsPanelOpened(false);
    setIsConvertCompressDialogOpen(true);
    return Upload.LIST_IGNORE;
  };

  if (isVideo) {
    const fileSizeMB = file.size / (1024 * 1024);

    if (fileSizeMB > 16) {
      message.error(
        "File is too large (max 16MB). Please choose a smaller file.",
      );
      return Upload.LIST_IGNORE;
    }
  }

  if (isVideo && file.type !== "video/mp4") {
    message.error("File must be a .mp4!");
    return Upload.LIST_IGNORE;
  }

  if (
    isImage &&
    (!isValidSize || !["image/jpeg", "image/png"].includes(file.type))
  ) {
    return openConvertCompressDialog();
  }

  return true;
};
